// OTP API functions
import axios from "axios";
import { API_BASE_URL } from "../config";

// TODO: Re-enable OTP functionality in future
/*
// Send OTP to email address
export async function sendOTP(email) {
  try {
    const response = await axios.post(`${API_BASE_URL}/otp/send`, { email });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to send OTP" };
  }
}

// Verify OTP code
export async function verifyOTP(email, otp_code) {
  try {
    const response = await axios.post(`${API_BASE_URL}/otp/verify`, {
      email,
      otp_code
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to verify OTP" };
  }
}

// Resend OTP
export async function resendOTP(email) {
  try {
    const response = await axios.post(`${API_BASE_URL}/otp/resend`, { email });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to resend OTP" };
  }
}
*/

// Temporary placeholder functions (remove when re-enabling OTP)
export async function sendOTP(email) {
  console.log("OTP functionality temporarily disabled");
  return { message: "OTP functionality temporarily disabled" };
}

export async function verifyOTP(email, otp_code) {
  console.log("OTP functionality temporarily disabled");
  return { message: "OTP functionality temporarily disabled" };
}

export async function resendOTP(email) {
  console.log("OTP functionality temporarily disabled");
  return { message: "OTP functionality temporarily disabled" };
}

// --- Forgot-password specific endpoints ---
// Request OTP for forgot-password (backend: POST /api/otp/forgot-password/send)
export async function sendForgotPasswordOTP(email) {
  try {
    const response = await axios.post(`${API_BASE_URL}/otp/forgot-password/send`, { email });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to send forgot-password OTP" };
  }
}

// Reset password using OTP (backend: POST /api/otp/forgot-password/reset)
export async function resetPasswordWithOTP(email, otp_code, new_password) {
  try {
    const response = await axios.post(`${API_BASE_URL}/otp/forgot-password/reset`, {
      email,
      otp_code,
      new_password
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to reset password" };
  }
}
